import { Product } from "~/bff/types/Product";
import { Store } from "~/bff/types/Store";
import { WidgetDocs } from "~/bff/types/WidgetDocs";
import { ClickCollectStatuses } from "~/constants/data-layer";
import { Nullable } from "~/types/general.types";

export const clickAndCollectOverallStatusGA = (
  product: Nullable<Product> | WidgetDocs | undefined,
  currentStore: Store | undefined | null,
): string | boolean => {
  if (!currentStore?.geomodifier) {
    return ClickCollectStatuses.notYetKnown;
  }

  if (!product?.clickAndCollectExclusive && !product?.clickAndCollect) {
    return false;
  }

  if (
    (product?.clickAndCollectExclusive || product?.clickAndCollect) &&
    currentStore?.clickAndCollectStore
  ) {
    return true;
  }

  return false;
};
